/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const GetEntityInputJsonApiModel = {
  id: "",
  filters: {
    jsonApi: "hasOne",
    type: "entity-filters",
  },
};
